import React from "react";
import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Control de actualizaciones del service worker.
 *
 * Decisión deliberada: el service worker está en modo "prompt", no
 * "autoUpdate". Una recarga automática en medio de una planificación —con
 * waypoints puestos y pesos cargados— haría perder el trabajo. La versión
 * nueva se instala en segundo plano y espera; el usuario aplica cuando quiere.
 */
export default function UpdateToast() {
  const {
    offlineReady: [listaSinRed, setListaSinRed],
    needRefresh: [hayActualizacion, setHayActualizacion],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(url, registro) {
      if (!registro) return;
      // Busca versión nueva cada 30 min mientras la app esté abierta.
      setInterval(() => registro.update(), 30 * 60 * 1000);
    },
    onRegisterError(error) {
      console.error("No se pudo registrar el service worker:", error);
    },
  });

  if (!listaSinRed && !hayActualizacion) return null;

  const cerrar = () => {
    setListaSinRed(false);
    setHayActualizacion(false);
  };

  return (
    <div className="hc-toast hc-no-print" role="status" aria-live="polite">
      {hayActualizacion ? (
        <>
          <span>Hay una versión nueva instalada y lista.</span>
          <span className="hc-bar__spacer" />
          <button type="button" className="hc-btn" onClick={cerrar}>
            Ahora no
          </button>
          <button
            type="button"
            className="hc-btn hc-btn--primary"
            onClick={() => updateServiceWorker(true)}
          >
            Aplicar y recargar
          </button>
        </>
      ) : (
        <>
          <span>HeliCalc quedó disponible sin conexión.</span>
          <span className="hc-bar__spacer" />
          <button type="button" className="hc-btn" onClick={cerrar}>
            Entendido
          </button>
        </>
      )}
    </div>
  );
}
